import React, { Component, PropTypes } from 'react';
import { DateField } from '../Inputs';
import moment from 'moment';

let $ = window.jQuery;

export default class DateStartEndField extends Component {
    static propTypes = {
        start_id: PropTypes.string.isRequired,
        end_id: PropTypes.string.isRequired,
        startDate: PropTypes.string.isRequired,
        endDate: PropTypes.string.isRequired
    };

    state = {
        startDate : '',
        endDate: '',
        startDateMax: '',
        endDateMin: ''
    };

    componentDidMount() {
        this.setState({
            startDate: this.props.startDate,
            endDate: this.props.endDate,
            startDateMax: moment(this.props.endDate, 'MMM DD, YYYY').subtract(1, 'days').format('MMM DD, YYYY'),
            endDateMin: moment(this.props.startDate, 'MMM DD, YYYY').add(1, 'days').format('MMM DD, YYYY')
        }, ()=>{
            $('#'+this.props.start_id).datepicker('setEndDate', moment(this.props.endDate, 'MMM DD, YYYY').subtract(1, 'days').format('MMM DD, YYYY'))
            $('#'+this.props.end_id).datepicker('setStartDate', moment(this.props.startDate, 'MMM DD, YYYY').add(1, 'days').format('MMM DD, YYYY'))
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            startDate: nextProps.startDate,
            endDate: nextProps.endDate,
            startDateMax: moment(nextProps.endDate, 'MMM DD, YYYY').subtract(1, 'days').format('MMM DD, YYYY'),
            endDateMin: moment(nextProps.startDate, 'MMM DD, YYYY').add(1, 'days').format('MMM DD, YYYY')
        }, ()=>{
            $('#'+this.props.start_id).datepicker('setEndDate', moment(nextProps.endDate, 'MMM DD, YYYY').subtract(1, 'days').format('MMM DD, YYYY'))
            $('#'+this.props.end_id).datepicker('setStartDate', moment(nextProps.startDate, 'MMM DD, YYYY').add(1, 'days').format('MMM DD, YYYY'))
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    handleStartDateChange = (e) => {
        let startDate = e.target.value;
        let endDateMin = moment(e.target.value, 'MMM DD, YYYY').add(1, 'days').format('MMM DD, YYYY');

        this.setState({
            startDate,
            endDateMin // endDate's minimum date should be startDate + 1
        }, ()=>{
            $('#'+this.props.end_id).datepicker('setStartDate', endDateMin)

            this.props.onChange(this.state.startDate, this.state.endDate);
        })
    }

    handleEndDateChange = (e) => {
        let endDate = e.target.value;
        let startDateMax = moment(e.target.value, 'MMM DD, YYYY').subtract(1, 'days').format('MMM DD, YYYY');

        this.setState({
            endDate,
            startDateMax // startDate's maximum date should be endDate - 1
        }, ()=>{
            $('#'+this.props.start_id).datepicker('setEndDate', startDateMax)

            this.props.onChange(this.state.startDate, this.state.endDate);
        })
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-6">
                    <DateField id={this.props.start_id} label="Start Date *"
                               help="Select start date..."
                               onChange={this.handleStartDateChange}
                               val={this.state.startDate}
                               endDate={this.state.startDateMax} />
                </div>
                <div className="col-md-6">
                    <DateField id={this.props.end_id} label="End Date *"
                               help="Select end date..."
                               onChange={this.handleEndDateChange}
                               val={this.state.endDate}
                               startDate={this.state.endDateMin} />
                </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/DateStartEndField.js
 **/